import { Fragment } from "react";

/**
 * Splits text on quoted passages — supports both "double" and 'single' quotes.
 */
function splitOnQuotes(text: string): string[] {
  // Match "double quoted" or 'single quoted' passages (excluding apostrophes in contractions)
  return text.split(/("(?:[^"\\]|\\.)+?"|'(?:[^'\\]|\\.){4,}?')/g);
}

function isQuoted(part: string): boolean {
  return (
    (part.startsWith('"') && part.endsWith('"')) ||
    (part.startsWith("'") && part.endsWith("'") && part.length > 5)
  );
}

/**
 * Renders text with quoted passages styled distinctly.
 * Quotes are shown in italic with a subtle background highlight.
 */
export function InlineCitation({ text, className = "" }: { text: string; className?: string }) {
  const parts = splitOnQuotes(text);

  return (
    <span className={className}>
      {parts.map((part, i) => {
        if (isQuoted(part)) {
          return (
            <span key={i} className="italic bg-amber-100/50 px-1 py-0.5 rounded">
              {part}
            </span>
          );
        }
        return <Fragment key={i}>{part}</Fragment>;
      })}
    </span>
  );
}

/**
 * Light-theme variant for student-facing pages.
 */
export function InlineCitationLight({
  text,
  className = "",
}: {
  text: string;
  className?: string;
}) {
  const parts = splitOnQuotes(text);

  return (
    <span className={className}>
      {parts.map((part, i) => {
        if (isQuoted(part)) {
          return (
            <span
              key={i}
              className="italic bg-amber-50 px-1 py-0.5 rounded text-content-foreground border border-amber-200/50"
            >
              {part}
            </span>
          );
        }
        return <Fragment key={i}>{part}</Fragment>;
      })}
    </span>
  );
}
